<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div
        class="detail_top_item"
        v-for="(item, index) in gridList"
        :key="index"
      >
        <div class="detail_top_item_title">{{ item.value }}</div>
        <div class="detail_top_item_value">{{ item.label }}</div>
      </div>
    </div>
    <div class="content_wrap">
      <div class="wrap_con_box">
        <div class="table_header">
          <div class="table_header_title">Organizational Structure</div>
          <div class="table_header_menus">
            <el-button>Batch Email Sending</el-button>
            <el-button disabled>Batch Batch</el-button>
            <el-button disabled>Add Customer</el-button>
            <el-button>Ai Email Assistant</el-button>
          </div>
        </div>
        <div class="detail_echart_con_box">
          <div ref="chart" class="org_chart"></div>
          <div class="graph_controls">
            <button
              @click="fullScreen"
              v-if="!isFullScreen"
              class="btn_control"
            >
              <i class="iconfont icon-quanping" />
            </button>
            <button @click="exitFullScreen" v-else class="btn_control">
              <i class="iconfont icon-suohui" />
            </button>
            <button @click="zoomLarge" class="btn_control">
              <i class="iconfont icon-fangda" />
            </button>
            <button @click="zoomSmall" class="btn_control">
              <i class="iconfont icon-suoxiao" />
            </button>
            <button @click="resetZoom" class="btn_control">
              <i class="iconfont icon-huanyuan" />
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="depart_box">
        <input type="checkbox" />
        <div class="depart_box_title">Administration Department</div>
      </div>
      <div class="person_box">
        <div class="person_box_title">Supervisor</div>
        <div class="person_box_name">
          <input type="checkbox" />
          <div class="person_box_name_title">Luca Maestri</div>
        </div>
        <div class="person_box_icon">
          <i class="iconfont icon-youxiang1" />
          <i class="iconfont icon-dianhuaheshi" />
          <img src="../../assets/images/icon_in.png" />
          <img src="../../assets/images/icon_f.png" />
          <img src="../../assets/images/icon_x.png" />
        </div>
        <div class="person_box_verified"><i class="iconfont icon-dagou" /></div>
      </div> -->
    </div>

    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import * as d3 from "d3";
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import Tips from "@/views/newLayout/tips.vue";

export default {
  name: "UboDetail2",
  mixins: [mixins1],
  components: {
    Page,
    Tips,
  },
  data() {
    return {
      loading: false,
      isShowTips: false,
      isShowD3: false,
      gridList: [
        { label: "Number of Personnel", value: "100" },
        { label: "Number of Department", value: "40" },
        { label: "Number of Phone", value: "50" },
        { label: "Number of Email", value: "150" },
        { label: "Mining Rate", value: "60%" },
        { label: "Certification Rate", value: "30%" },
      ],
      isFullScreen: false,
      svg: null,
      g: null,
      zoom: null,
      currentTransform: d3.zoomIdentity,
      root: null,
      echartData: {
        id: "1",
        name: "Tim Cook",
        type: "person",
        title: "Chairman / Director and General Manager",
        verified: true,
        checked: false,
        contacts: ["email", "skype", "linkedin", "facebook", "x"],
        children: [
          {
            id: "3",
            name: "Administration Department",
            type: "department",
            deptType: "admin",
            checked: false,
            children: [
              {
                id: "4",
                name: "Luca Maestri",
                type: "person",
                title: "Supervisor",
                verified: true,
                checked: false,
                contacts: ["email", "skype", "linkedin", "facebook", "x"],
                children: [
                  {
                    id: "5",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: false,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                  {
                    id: "6",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: true,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                ],
              },
            ],
          },

          {
            id: "7",
            name: "Marketing Department",
            type: "department",
            deptType: "marketing",
            checked: false,
            children: [
              {
                id: "8",
                name: "Aadff Luca",
                type: "person",
                title: "Supervisor",
                verified: true,
                checked: false,
                contacts: ["email", "skype", "linkedin", "facebook", "x"],
                children: [
                  {
                    id: "9",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: false,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                  {
                    id: "10",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: false,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                ],
              },
            ],
          },

          {
            id: "11",
            name: "Development Department",
            type: "department",
            deptType: "dev",
            checked: false,
            children: [
              {
                id: "12",
                name: "Aadff Luca",
                type: "person",
                title: "Supervisor",
                verified: true,
                checked: false,
                contacts: ["email", "skype", "linkedin", "facebook", "x"],
                children: [
                  {
                    id: "13",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: false,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                  {
                    id: "14",
                    name: "Albert A. Gore Jr.",
                    type: "person",
                    title: "Staff",
                    verified: false,
                    checked: false,
                    contacts: ["email", "skype", "linkedin", "facebook", "x"],
                  },
                ],
              },
            ],
          },
        ],
      },
      colorMap: {
        top: "#1290C9",
        admin: "#6b4f3b",
        marketing: "#f57c00",
        dev: "#2aa198",
      },
    };
  },
  methods: {
    echartInit() {
      this.svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", "100%")
        .attr("height", 920);

      this.zoom = d3.zoom().on("zoom", (e) => {
        this.currentTransform = e.transform;
        this.g.attr("transform", this.currentTransform);
      });

      this.svg.call(this.zoom);

      this.g = this.svg.append("g");

      this.drawOrgChart();
    },
    drawOrgChart() {
      this.g.selectAll("*").remove();

      // 设置父节点引用以实现级联逻辑
      this.setParents(this.echartData);

      const containerWidth = this.$refs.chart.clientWidth || 1000;
      const containerPadding = 40;

      // 收集层次数据
      const root = this.echartData;
      const ceo = root;
      let deputies = root.children || [];

      // 如果根节点的 children 本身就是部门，则直接把它当作部门处理（不绘制副总行）
      const isDeptLevel =
        deputies.length > 0 && deputies.every((d) => d.type === "department");

      let departments = [];
      if (isDeptLevel) {
        departments = deputies;
        deputies = [];
      } else {
        // 收集部门：副总的子节点
        deputies.forEach((d) => {
          if (d.children && d.children.length) {
            d.children.forEach((c) => {
              departments.push(c);
            });
          }
        });

        if (departments.length === 0) {
          deputies.forEach((d) => {
            if (d.title && d.title.toLowerCase().includes("department")) {
              departments.push(d);
            }
          });
        }

        if (departments.length === 0) {
          if (root.children) {
            root.children.forEach((c) => {
              if (c.children) c.children.forEach((cc) => departments.push(cc));
            });
          }
        }
      }

      // 布局参数
      const nCols = Math.max(1, departments.length || 3);
      const colWidth = Math.max(
        350,
        Math.floor((containerWidth - containerPadding * 2) / nCols),
      );
      const startX =
        (containerWidth - nCols * colWidth) / 2 + containerPadding / 2;

      const cardW = 330;
      const cardH = 116;
      const cardHalfH = cardH / 2;
      const deptH = 50;
      const deptHalfH = deptH / 2;

      // CEO
      const ceoX = containerWidth / 2;
      const ceoY = 40;
      this.drawCard(
        this.g,
        ceoX,
        ceoY,
        ceo,
        this.colorMap.top || "#4a90e2",
        true,
        (checked) => {
          ceo.checked = checked;
        },
      );

      // 计算部门行 y
      const deputyY = ceoY + 120;
      const deputyLineY = deputyY; // 在副总中心连接

      const hasDeputies = deputies.length > 0;
      const deptY = hasDeputies ? deputyLineY + 160 : ceoY + 160;

      // 如果有副总，则绘制副总行和连接线
      if (hasDeputies) {
        const deputyXs = [];
        if (deputies.length === 1) {
          deputyXs.push(ceoX);
        } else if (deputies.length === 2) {
          deputyXs.push(ceoX - 260, ceoX + 260);
        } else {
          const span = Math.min(600, (nCols * colWidth) / 1.5);
          for (let i = 0; i < deputies.length; i++)
            deputyXs.push(ceoX - span / 2 + (span / (deputies.length - 1)) * i);
        }

        deputies.forEach((d, i) => {
          const dx = deputyXs[i] || ceoX + (i - 0.5) * 260;
          this.drawCard(
            this.g,
            dx,
            deputyY,
            d,
            this.colorMap.top || "#1290C9",
            true,
            (checked) => {
              d.checked = checked;
            },
          );
        });

        // 从CEO到副总行的垂直线
        this.g
          .append("line")
          .attr("x1", ceoX)
          .attr("y1", ceoY + cardHalfH)
          .attr("x2", ceoX)
          .attr("y2", deputyLineY)
          .attr("stroke", "#ccc")
          .attr("stroke-width", 2);

        // 副总之间的水平线
        const leftDeputyX = deputyXs[0];
        const rightDeputyX = deputyXs[deputies.length - 1];
        this.g
          .append("line")
          .attr("x1", leftDeputyX)
          .attr("y1", deputyLineY)
          .attr("x2", rightDeputyX)
          .attr("y2", deputyLineY)
          .attr("stroke", "#ccc")
          .attr("stroke-width", 2);
      } else {
        // 如果没有副总，直接从CEO向下到部门
        this.g
          .append("line")
          .attr("x1", ceoX)
          .attr("y1", ceoY + cardHalfH)
          .attr("x2", ceoX)
          .attr("y2", deptY - deptHalfH)
          .attr("stroke", "#ccc")
          .attr("stroke-width", 2);
      }

      // 放置每个部门列（布局调整以匹配设计）
      departments.forEach((dept, idx) => {
        const colStartX = startX + idx * colWidth;
        const colCenterX = colStartX + colWidth / 2;

        dept.color = this.colorMap[dept.deptType] || "#6b4f3b";

        // 部门卡片（仅显示名字）
        this.drawCard(
          this.g,
          colCenterX,
          deptY,
          dept,
          dept.color,
          false,
          (checked) => {
            dept.checked = checked;
          },
        );

        // 从副总行向下到部门的垂直连接线
        this.drawLine(
          this.g,
          colCenterX,
          deputyLineY + cardHalfH,
          colCenterX,
          deptY - deptHalfH,
        );

        // 主管卡片
        const supervisorNode = (dept.children && dept.children[0]) || {};
        const supervisorY = deptY + cardH + 40;
        this.drawCard(
          this.g,
          colCenterX,
          supervisorY,
          supervisorNode,
          dept.color,
          true,
          (checked) => {
            supervisorNode.checked = checked;
          },
        );

        // 从部门向下通过主管和员工的垂直主干线
        const staffs = supervisorNode.children || dept.staff || [];
        const staffStartY = supervisorY + cardH + 40;
        const staffLastY =
          staffStartY + Math.max(0, staffs.length - 1) * (cardH + 30);
        const spineBottomY = staffs.length
          ? staffLastY + cardHalfH
          : supervisorY + cardHalfH;

        this.g
          .append("line")
          .attr("x1", colCenterX)
          .attr("y1", supervisorY + cardHalfH)
          .attr("x2", colCenterX)
          .attr("y2", spineBottomY)
          .attr("stroke", "#ccc")
          .attr("stroke-width", 2);

        // 员工列表（垂直堆叠）
        staffs.forEach((sName, sIdx) => {
          const sy = staffStartY + sIdx * (cardH + 30);
          const staffData =
            typeof sName === "object"
              ? sName
              : { name: sName, title: "Staff", checked: false };
          this.drawCard(
            this.g,
            colCenterX,
            sy,
            staffData,
            dept.color,
            true,
            (checked) => {
              staffData.checked = checked;
            },
          );
        });
      });
    },

    drawLabelBar(g, x, y, width, height, color, text, options = {}) {
      // options = { showCheckbox: true }
      g.append("rect")
        .attr("x", x)
        .attr("y", y)
        .attr("width", width)
        .attr("height", height)
        .attr("rx", 3)
        .attr("fill", color);

      const hasCheckbox = options.showCheckbox;
      let textAnchor = "middle";
      let textX = x + width / 2;

      if (hasCheckbox) {
        const checkboxSize = 14;
        const checkboxX = x + 10;
        const checkboxY = y + (height - checkboxSize) / 2;
        g.append("rect")
          .attr("x", checkboxX)
          .attr("y", checkboxY)
          .attr("width", checkboxSize)
          .attr("height", checkboxSize)
          .attr("rx", 2)
          .attr("fill", "#fff")
          .attr("stroke", "#fff");

        textAnchor = "start";
        textX = x + 34;
      }

      g.append("text")
        .attr("x", textX)
        .attr("y", y + height / 2 + 5)
        .attr("text-anchor", textAnchor)
        .attr("font-size", 12)
        .attr("fill", "#fff")
        .attr("font-weight", "bold")
        .text(text);
    },

    drawCard(g, x, y, data, color, showTitle = true, onToggle) {
      const cardW = 320;
      const cardH = 116;
      const deptH = 50;
      const width = cardW;
      const height = data.type === "department" ? deptH : cardH;
      const halfH = height / 2;

      const fo = g
        .append("foreignObject")
        .attr("width", width)
        .attr("height", height)
        .attr("x", x - width / 2)
        .attr("y", y - halfH);

      let cardHtml = "";

      if (data.type === "department") {
        cardHtml = `
        <div class="depart_box" style="background:${color}">
          <input type="checkbox" ${data.checked ? "checked" : ""}/>
          <div class="depart_box_title">${data.name}</div>
        </div>
      `;
      } else {
        cardHtml = `
          <div class="person_box">
            <div class="person_box_title" style="background:${color}">${
          data.title || ""
        }</div>
            <div class="person_box_name">
              <input type="checkbox" ${data.checked ? "checked" : ""}/>
              <div class="person_box_name_title">${data.name || ""}</div>
            </div>
            <div class="person_box_icon">
              <i class="iconfont icon-youxiang1" />
              <i class="iconfont icon-dianhuaheshi" />
              <img src="${require("../../assets/images/icon_in.png")}" />
              <img src="${require("../../assets/images/icon_f.png")}"/>
              <img src="${require("../../assets/images/icon_x.png")}"/>
            </div>
            <div class="person_box_verified ${
              data.verified ? "active" : ""
            }" ><i class="iconfont icon-dagou" /></div>
          </div>
        `;
      }

      fo.html(cardHtml);

      if (data.type !== "department") {
        // 绑定复选框切换
        fo.select(".org-checkbox").on(
          "change",
          function () {
            const cb = d3.select(this);
            const checked = cb.property("checked");
            data.checked = checked;
            // 级联
            this.setChildrenChecked(data, checked);
            this.updateParentChecked(data);
            // 重绘以保持复选框状态同步
            this.drawOrgChart();
            if (typeof onToggle === "function") onToggle(checked);
          }.bind(this),
        );

        // 点击卡片切换
        fo.select(".org-card").on(
          "click",
          function () {
            const cb = fo.select(".org-checkbox");
            const checked = !cb.property("checked");
            cb.property("checked", checked);
            data.checked = checked;
            // 级联
            this.setChildrenChecked(data, checked);
            this.updateParentChecked(data);
            // 重绘以保持复选框状态同步
            this.drawOrgChart();
            if (typeof onToggle === "function") onToggle(checked);
          }.bind(this),
        );
      }
    },

    drawLine(g, x1, y1, x2, y2) {
      g.append("line")
        .attr("x1", x1)
        .attr("y1", y1)
        .attr("x2", x2)
        .attr("y2", y2)
        .attr("stroke", "#ccc")
        .attr("stroke-width", 2);
    },

    // 设置父节点引用以实现级联逻辑
    setParents(node, parent = null) {
      node.parent = parent;
      if (node.children) {
        node.children.forEach((child) => this.setParents(child, node));
      }
    },

    // 🔽 向下全选
    setChildrenChecked(node, checked) {
      if (node.children) {
        node.children.forEach((child) => {
          child.checked = checked;
          this.setChildrenChecked(child, checked);
        });
      }
    },

    // 🔼 向上联动
    updateParentChecked(node) {
      if (!node.parent) return;

      const siblings = node.parent.children;
      const allChecked = siblings.every((n) => n.checked);

      node.parent.checked = allChecked;

      this.updateParentChecked(node.parent);
    },

    // 工具栏

    // 全屏
    fullScreen() {
      const elem = this.$el.querySelector(".detail_echart_con_box");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.isFullScreen = true;
    },
    // 退出全屏
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.isFullScreen = false;
    },
    // 放大
    zoomLarge() {
      this.svg.transition().duration(300).call(this.zoom.scaleBy, 1.2);
    },
    //缩小
    zoomSmall() {
      this.svg.transition().duration(300).call(this.zoom.scaleBy, 0.8);
    },
    // 重置
    resetZoom() {
      const targetNode = this.nodes.find((d) => d.type === "target");
      const offsetX = targetNode ? -targetNode.x : 0;
      const offsetY = targetNode ? -targetNode.y : 0;
      this.svg
        .transition()
        .duration(300)
        .call(
          this.zoom.transform,
          d3.zoomIdentity
            .translate(this.width / 2, this.height / 2)
            .translate(offsetX, offsetY),
        );
    },
  },
  mounted() {
    this.echartInit();
  },
};
</script>
<style>
.depart_box {
  width: 320px;
  height: 50px;
  background: #603c2c;
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 14px;
}
.depart_box_title {
  flex: 1;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}
.person_box {
  width: 320px;
  height: 116px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #cccccc;

  position: relative;
}
.person_box_title {
  width: 100%;
  height: 30px;
  background: #603c2c;
  border-radius: 4px 4px 0px 0px;
  font-size: 16px;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
}
.person_box_name {
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}
.person_box_name_title {
  flex: 1;
  font-family: "Arial Bold";
  font-size: 16px;
  color: #1a2332;
  line-height: 18px;
  text-align: center;
}
.person_box_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.person_box_icon i {
  color: #1290c9;
  font-size: 20px;
}
.person_box_icon img {
  width: 20px;
  height: 20px;
}
.person_box_verified {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 30px;
  height: 30px;
  background: #eeeeee;
  border-radius: 10px 0px 4px 0px;
  text-align: center;
  line-height: 30px;
}
.person_box_verified i {
  font-size: 26px;
  color: #999999;
}
.person_box_verified.active {
  background: #3fb92f;
}
.person_box_verified.active i {
  color: #ffffff;
}
</style>
<style scoped>
.detail_top_item {
  background: #f0effc;
}
.detail_top_item_title {
  color: #8e86dd;
}
.table_header_menus button {
  background-color: #8e86dd;
  color: #ffffff;
}
.table_header_menus button.is-disabled {
  background: #eeeeee;
  color: #999999;
}
.content_wrap {
  padding: 0;
  padding-bottom: 10px;
}
.wrap_search_box {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.wrap_search_box .el-collapse,
.wrap_search_box .el-collapse-item {
  border: none;
}
.wrap_search_box >>> .el-collapse-item__header,
.wrap_search_box >>> .el-collapse-item__wrap {
  background: #ffffff;
}
.wrap_con_box {
  padding: 30px;
}
.table_header {
  margin-bottom: 12px;
}
.detail_echart_con_box {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  background: #ffffff;
}
.org_chart {
  width: 100%;
  height: 100%;
  min-height: 600px;
}

.graph_controls {
  position: absolute;
  top: 100px;
  right: 20px;
  z-index: 8;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 40px;
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.btn_control {
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  transition: all 0.3s;
}
.btn_control i {
  font-size: 20px;
}

.btn_control:hover {
  background-color: #f0f0f0;
  border-color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn_control:active {
  background-color: #e0e0e0;
}

@media (max-width: 1920px) {
  .content_wrap {
    padding-bottom: 7px;
  }
  .wrap_con_box {
    padding: 22px;
  }
  .table_header {
    margin-bottom: 10px;
  }
}
</style>
